import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CmgUseEntree'
})
export default class CmgUseEntree extends Vue {
  @Prop({ required: true, type: String })
  name!: string;

  @Prop({ default: false, type: Boolean })
  removable!: boolean;

  @Prop({ type: Boolean })
  useMedallionStyling!: boolean;

  get iconImageUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionFluted.default;
  }

  get removePromoImageUrl(): string {
    return this.$appStore.state.cms.images.buttons.closeSmall.default;
  }

  onClick() {
    this.$emit('click')
  }

  onClickRemove() {
    this.$emit('remove');
  }
}